import React, { useState } from "react";
import { useMsal } from "@azure/msal-react";
import { InteractionStatus } from "@azure/msal-browser";
import { loginRequest } from "../authConfig";
import "../styles/login.css";
import logo from "../assets/images/cto_logo.png";

function LoginPage() {
  const { instance, inProgress } = useMsal();
  const [error, setError] = useState("");
  const isBusy = inProgress !== InteractionStatus.None;

  const handleLogin = () => {
    setError("");
    instance.loginRedirect(loginRequest).catch(() => {
      setError("We couldn\'t start the sign-in process. Please try again.");
    });
  };

  return (
    <div className="login-screen">
      <div className="login-brand-panel">
        <div className="brand-mark">
          <span className="brand-glyph">
            <img src={logo} alt="Cloud Techon" className="brand-logo" />
          </span>
          <span className="brand-name">CLOUD TECHON</span>
        </div>

        <div className="brand-copy">
          <h1>Internal Employee<br />Platform</h1>
          <p>
            One secure workspace for all your company tools -
            document management, leave tracking, payroll, and more.
          </p>
        </div>

        <ul className="brand-points">
          <li>Single sign-on with your Microsoft account</li>
          <li>All internal tools in one place</li>
          <li>Enterprise-grade security & audit logging</li>
        </ul>

        <div className="brand-footer">CLOUD TECHON - Internal use only</div>
      </div>

      <div className="login-form-panel">
        <div className="login-card">
          <h2 className="login-heading">Sign in</h2>
          <p className="login-subheading">
            Use your work Microsoft account to access the platform.
          </p>

          <button
            className="ms-signin-button"
            onClick={handleLogin}
            disabled={isBusy}
          >
            <svg width="18" height="18" viewBox="0 0 21 21">
              <rect x="1" y="1" width="9" height="9" fill="#f25022" />
              <rect x="11" y="1" width="9" height="9" fill="#7fba00" />
              <rect x="1" y="11" width="9" height="9" fill="#00a4ef" />
              <rect x="11" y="11" width="9" height="9" fill="#ffb900" />
            </svg>
            {isBusy ? "Redirecting..." : "Sign in with Microsoft"}
          </button>

          {error && (
            <div className="login-error" role="alert">{error}</div>
          )}

          <div className="login-security-note">
            <LockIcon />
            <span>
              Your credentials are verified directly by Microsoft.
              This platform never sees or stores your password.
            </span>
          </div>
        </div>

        <p className="login-help">
          Trouble signing in? Contact your IT administrator.
        </p>
      </div>
    </div>
  );
}

function DocStackIcon() {
  return (
    <svg width="26" height="26" viewBox="0 0 24 24" fill="none">
      <rect x="5" y="3" width="12" height="15" rx="1.5" fill="currentColor" opacity="0.35" />
      <rect x="7" y="6" width="12" height="15" rx="1.5" fill="currentColor" opacity="0.65" />
      <rect x="9" y="9" width="12" height="12" rx="1.5" fill="currentColor" />
    </svg>
  );
}

function LockIcon() {
  return (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
      <rect x="5" y="11" width="14" height="9" rx="2" stroke="currentColor" strokeWidth="1.6" />
      <path d="M8 11V8a4 4 0 0 1 8 0v3" stroke="currentColor" strokeWidth="1.6" />
    </svg>
  );
}

export default LoginPage;
